export default "__VITE_ASSET__D93V2B9Z__"